module.exports = __webpack_public_path__ + "static/mack_video-54bd5416592749eb802d86cc689e58de.jpg";